var map = {
	"./_template.yaml": 21,
	"./binaryAdd.yaml": 22,
	"./binaryIncrement.yaml": 23,
	"./binaryMult.yaml": 24,
	"./busyBeaver3.yaml": 25,
	"./busyBeaver4.yaml": 26,
	"./copy1s.yaml": 27,
	"./divisibleBy3.yaml": 28,
	"./divisibleBy3Base10.yaml": 29,
	"./lengthMult.yaml": 30,
	"./matchBinaryStrings.yaml": 31,
	"./matchThreeLengths.yaml": 32,
	"./palindrome.yaml": 33,
	"./powersOfTwo.yaml": 34,
	"./repeat01.yaml": 35,
	"./unaryMult.yaml": 36
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40;



//////////////////
// WEBPACK FOOTER
// ./src/examples ./~/raw-loader!^\.\/.*\.yaml$
// module id = 40
// module chunks = 1